function retrieveCrewDefaultAcceptance(companyId) {
    return window.tenantAxios.get(`/company/${companyId}/crew-default-acceptance`);
}

function updateCrewDefaultAcceptance(companyId, crewDefaultAcceptance) {
    return window.tenantAxios.patch(`/company/${companyId}/crew-default-acceptance`, crewDefaultAcceptance);
}

export default {
    retrieveCrewDefaultAcceptance,
    updateCrewDefaultAcceptance,
};
